import { render, staticRenderFns } from "./CreateUpdateService.vue?vue&type=template&id=6b39b632&"
import script from "./CreateUpdateService.vue?vue&type=script&lang=js&"
export * from "./CreateUpdateService.vue?vue&type=script&lang=js&"
import style0 from "./CreateUpdateService.vue?vue&type=style&index=0&id=6b39b632&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports